import { useTranslation } from "react-i18next";

type Props = {
  helpedCount?: number;
  isFirstToday?: boolean;
};

export function SuccessFeedback({ helpedCount, isFirstToday }: Props) {
  const { t } = useTranslation();
  // Falsy covers both queued-offline (undefined) and backend-degraded (0).
  // Both deserve a confirmation; neither has the data for the celebration panel.
  if (!helpedCount) {
    return (
      <p role="status" className="text-sm text-volt-deep">
        {t("reports.success")}
      </p>
    );
  }
  return (
    <div
      role="status"
      data-testid="report-success-feedback"
      className="surface-cinematic glow-volt reveal relative overflow-hidden px-4 py-3"
    >
      {isFirstToday && (
        <p className="eyebrow text-volt-deep">
          ✨ {t("reports.feedback.first_today")}
        </p>
      )}
      <p className={`text-sm text-fg ${isFirstToday ? "mt-1" : ""}`}>
        {t("reports.feedback.helped_count", { count: helpedCount })}
      </p>
    </div>
  );
}
